import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { GAME_TYPE_LIST, getGameType } from '../../variables/gameTypes';
import IconSave from '../../components/icons/IconSave';
import '../../css/modals.css';
import '../../css/games.css';

// Create/edit modal for a Grid (a single game instance). Bespoke rather than
// the legacy Form.jsx, because Form.jsx's "select" field only supports
// API-backed option lists (via Selector.jsx) - the game type is a fixed set
// of 4, best shown as a colored pill picker, not a dropdown hitting an API.
export default function GameModal({ modalState, gameId, defaultType, onClose, onSaved }) {
   const navigate = useNavigate();
   const isOpen = modalState === 'create' || modalState === 'edit';
   const isEdit = modalState === 'edit';
   const [name, setName] = useState('');
   const [type, setType] = useState(defaultType || 1);
   const [initial, setInitial] = useState({ name: '', type: defaultType || 1 });
   const [saving, setSaving] = useState(false);
   const [error, setError] = useState('');

   useEffect(() => {
      if(!isOpen) return;
      if(isEdit && gameId) {
         axios.get('/api/grid/' + gameId, { withCredentials: true })
            .then(response => {
               const nextName = response.data.name || '';
               const nextType = response.data.type || 1;
               setName(nextName);
               setType(nextType);
               setInitial({ name: nextName, type: nextType });
            })
            .catch(err => {
               if(err.response && err.response.status === 401) navigate('/login');
            });
      } else {
         setName('');
         setType(defaultType || 1);
         setInitial({ name: '', type: defaultType || 1 });
      }
      setError('');
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [modalState, gameId]);

   if(!isOpen) return '';

   const dirty = name.trim() !== initial.name || type !== initial.type;
   const canSave = name.trim().length > 0 && (isEdit ? dirty : true);

   const handleSave = () => {
      if(!canSave || saving) return;
      setSaving(true);
      setError('');
      const payload = { name: name.trim(), type };
      const request = isEdit
         ? axios.put('/api/grid/' + gameId, JSON.stringify(payload), { withCredentials: true, headers: { 'Content-Type': 'application/json' } })
         : axios.post('/api/grid', JSON.stringify(payload), { withCredentials: true, headers: { 'Content-Type': 'application/json' } });
      request.then(response => {
         setSaving(false);
         onSaved(response.data);
      }).catch(err => {
         setSaving(false);
         if(err.response && err.response.status === 401) { navigate('/login'); return; }
         setError('Не вдалося зберегти гру');
      });
   };

   const stopProp = e => e.stopPropagation();

   return (
      <div className="modal-update" onClick={onClose} style={{ display: 'flex' }}>
         <div className="modal-window games-modal-window" onClick={stopProp}>
            <h3 className="modal-w-title">{isEdit ? 'Редагування гри' : 'Нова гра'}</h3>

            <div className="games-modal-field">
               <label className="games-modal-label">Назва</label>
               <input className="games-modal-input" type="text" value={name}
                  placeholder="Наприклад: Тварини — рівень 1"
                  onChange={e => setName(e.target.value)} autoFocus />
            </div>

            <div className="games-modal-field">
               <label className="games-modal-label">Тип гри</label>
               {isEdit ? (
                  <div className="game-type-badge" style={{ '--accent': getGameType(type).accent }}>
                     {getGameType(type).label}
                  </div>
               ) : (
                  <div className="game-type-picker">
                     {GAME_TYPE_LIST.map(gt => (
                        <div key={gt.type}
                           className={'game-type-pill' + (type === gt.type ? ' active' : '')}
                           style={{ '--accent': gt.accent }}
                           onClick={() => setType(gt.type)}>
                           {gt.label}
                        </div>
                     ))}
                  </div>
               )}
            </div>

            {error ? <div className="games-modal-error">{error}</div> : ''}

            <div className="games-modal-actions">
               <button type="button" className="games-modal-save-btn" disabled={!canSave || saving} onClick={handleSave}>
                  <IconSave />
                  {saving ? 'Збереження...' : 'Зберегти'}
               </button>
            </div>
         </div>
      </div>
   );
}
